window.addEventListener("load", () => {
  const productVariantSelects = $('[data-product-variant-select]');
  const setProductVariantId = (productRef, variantId) => {
    productRef.attr("data-variant-id", `${variantId}`)
  }

  const formatProductPrice = (price) => {
    if(price != 0 ) {
      let stringPrice = price.toString();
      let formattedPrice = stringPrice.slice(0, -2) + '.' + stringPrice.slice(-2);
      return `$${formattedPrice}`;
    }
    return `$0`;
  }

  const setProductPriceByVariant = (productHandle, elementToAdd, variantId) => {
    jQuery.getJSON(`/products/${productHandle}.js`, function(product) {
      if (product.variants.length > 1) {
        product.variants.forEach(element => {
          if (element.id == variantId) {
            elementToAdd.text(formatProductPrice(element.price));
          }
        });
      }
      else {
        elementToAdd.text(formatProductPrice(product.price));
      }
    });
  }

  productVariantSelects.each((i, el) => {
    let elementToChangeFirstTime = $(el).next('[data-variant-id]');
    let productVariantIdFirstTime = $(el).val();  
    let productPriceElFirst = $(el).next('.button-secondary').children('.custom-card-button-text').children('.card-product-price');
    let productHandleFirst = $(el).attr('data-product-handle');

    setProductVariantId(elementToChangeFirstTime, productVariantIdFirstTime);
    setProductPriceByVariant(productHandleFirst, productPriceElFirst, productVariantIdFirstTime);

    $(el).change(function() {
      let elementToChange = $(el).next('[data-variant-id]');
      let productVariantId = $(el).val(); 
      let productPriceEl = $(el).next('.button-secondary').children('.custom-card-button-text').children('.card-product-price');
      let productHandle = $(el).attr('data-product-handle');

      setProductPriceByVariant(productHandle, productPriceEl, productVariantId);

      setProductVariantId(elementToChange, productVariantId);
    })

  });

});